"use client"
import {
  fullPageLoadingIndicator 
} from "@/components/LoadingIndicator"

export default function Loading() {
  return <>
    {fullPageLoadingIndicator}
  </>
}
